const STATUS_CODE = {
  INTERNAL_ERROR: 500,
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  METHOD_NOT_ALLOWED: 405,
  SERVICE_UNAVAILABLE: 503,
};

module.exports = STATUS_CODE;
